<div class="row" *ngIf="loading">
    <div class="col-12">
        <div
            style="min-height: 340px;;display: flex;flex-direction: column;justify-content: center;align-content: center;align-items: center;">
            <span>Verificando a existencia de planos...</span>
            <span>Aguarde alguns instantes...</span>
            <div class="spinner-border spinner-border-sm text-info m-1" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</div>
<div class="row" *ngIf="!loading">
    <div class="col-12" *ngIf="prjs.length == 0">
        <div style="margin-bottom: 10px; display: flex;flex-direction: column;justify-content: center;">
            <div style="align-self: center;text-align: center;">
                <div class="d-inline-block" placement="bottom-right">                    
                    <button type="button" class="btn btn-primary" (click)="cadastrarPlanoRecuperacaoJudicial()">
                        <i class="fas fa-plus-circle"></i> Adicionar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>